import { useHistory } from 'react-router-dom';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import SettingsCollection, { ArchiveRestoreMutationTuple } from '../generic/SettingsCollection';

export default function GoalLabelsListContainer() {
	const history = useHistory();
	const { localize } = useLocalize();

	return (
		<SettingsCollection
			query={graphql.usePaginatedLabelsQuery}
			lazyQuery={graphql.usePaginatedLabelsLazyQuery}
			field="paginatedLabels"
			translationKey="settings.goals.labels"
			title={(label: graphql.Label) => localize(label.title).text}
			link={(label) => `/settings/goals/labels/${label.id}`}
			variables={{ type: graphql.LabelType.Goal }}
			archive={graphql.useArchiveLabelMutation() as unknown as ArchiveRestoreMutationTuple}
			restore={graphql.useRestoreLabelMutation() as unknown as ArchiveRestoreMutationTuple}
			onAdd={() => history.push('/settings/goals/labels/new')}
		/>
	);
}
